import React, { useContext } from 'react';

import Accordion from 'react-bootstrap/Accordion';
import Card from 'react-bootstrap/Card';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import reduceRulesToScopeNames from '../../../Reducer/ReduceRulesToScopeNames';
import { Result } from '../../../Interface/Response/Validator/Result';
import ResultContext from '../../../Context/ResultContext';
import ScopeRow from './ScopeRow';

import useGetAcceptanceFeaturesMessages from '../../../Hook/Validator/UseGetAcceptanceFeaturesMessages';

const AcceptanceFeatures: React.FC = () => {
    const result = useContext<Result | null>(ResultContext);
    const messages = useGetAcceptanceFeaturesMessages();

    if (!result) {
        return null;
    }

    const scopesNames = reduceRulesToScopeNames(result.beoordeling.beoordelingResponse.regel);

    return (
        <Container fluid className="accordion-container">
            <Accordion>
                <Card className="accordion-container__header">
                    <Container fluid>
                        <Row>
                            <Col>Categorie</Col>
                            <Col>Voldoende</Col>
                            <Col>Twijfel</Col>
                            <Col>Onvoldoende</Col>
                            <Col>Informatief</Col>
                        </Row>
                    </Container>
                </Card>
                {messages && (
                    <Card className={`features-row`}>
                        <div className="card-header no-results-message">
                            <p>{messages.message}</p>
                        </div>
                    </Card>
                )}
                {scopesNames.map(scopeName => (
                    <ScopeRow key={scopeName} scopeName={scopeName} />
                ))}
            </Accordion>
        </Container>
    );
};

export default AcceptanceFeatures;
